export { default } from './refType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/refType/index.js
// module id = 60
// module chunks = 25